<!--============================
=            MARKET            =
=============================-->

<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Market</div>
      </base-header>
    </v-row>

    <v-row>
      <template>

        <v-col cols="12" md="3" sm="12">
          <base-card>
            <div slot="card-header">

              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 font-weight-black white--text">
                    BTCUSDT
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption font-weight-light white--text">$35.987
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
            <div slot="card-body">


              <v-card-text>
                <v-row>
                  <v-col class="text-h4 font-weight-black align-center white--text " cols="5">
                    35%
                  </v-col>
                  <v-col cols="7">
                    <v-sparkline :value="value" :fill="fill" color="rgba(255, 255, 255, .7)" height="100" padding="24"
                                 elevation="3" stroke-linecap="round" smooth>
                      <template v-slot:label="item">
                        ${{ item.value }}
                      </template>
                    </v-sparkline>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="3" sm="12">
          <base-card>
            <div slot="card-header">

              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 font-weight-black white--text">
                    BNBUSDT
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption font-weight-light white--text">$35.987
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
            <div slot="card-body">


              <v-card-text>
                <v-row>
                  <v-col class="text-h4 font-weight-black align-center white--text " cols="5">
                    35%
                  </v-col>
                  <v-col cols="7">
                    <v-sparkline :value="value" :fill="fill" color="rgba(255, 255, 255, .7)" height="100" padding="24"
                                 elevation="3" stroke-linecap="round" smooth>
                      <template v-slot:label="item">
                        ${{ item.value }}
                      </template>
                    </v-sparkline>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="3" sm="12">
          <base-card>
            <div slot="card-header">

              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 font-weight-black white--text">
                    ZILUSDT
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption font-weight-light white--text">$35.987
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
            <div slot="card-body">


              <v-card-text>
                <v-row>
                  <v-col class="text-h4 font-weight-black align-center white--text " cols="5">
                    35%
                  </v-col>
                  <v-col cols="7">
                    <v-sparkline :value="value" :fill="fill" color="rgba(255, 255, 255, .7)" height="100" padding="24"
                                 elevation="3" stroke-linecap="round" smooth>
                      <template v-slot:label="item">
                        ${{ item.value }}
                      </template>
                    </v-sparkline>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="3" sm="12">
          <base-card>
            <div slot="card-header">

              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 font-weight-black white--text">
                    EPSUSDT
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption font-weight-light white--text">$35.987
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
            <div slot="card-body">


              <v-card-text>
                <v-row align="center">
                  <v-col class="text-h4 font-weight-black white--text " cols="5">
                    35%
                  </v-col>
                  <v-col cols="7">
                    <v-sparkline :value="value" :fill="fill" color="rgba(255, 255, 255, .7)" height="100" padding="24"
                                 elevation="3" stroke-linecap="round" smooth>
                      <template v-slot:label="item">
                        ${{ item.value }}
                      </template>
                    </v-sparkline>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="4" sm="12">
          <base-card>
            <div slot="card-header">

              Trade Bot Verson Titan
            </div>
            <div slot="card-subheader">Minim do incididunt et sit. </div>
            <div slot="card-body">
              <v-list class="transparent white--text" dark dense>

                <v-list-item-group v-model="selectedItem" color="primary">
                  <v-list-item v-for="(item, i) in list1" :key="i">
                    <v-list-item-icon size="40" class="rounded-lg" :color="item.color">
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.title"></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn class="font-weight-bold " outlined :class="item.color" text>
                        {{item.price}}
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider inset></v-divider>
                </v-list-item-group>
              </v-list>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="8" sm="12">
          <base-card>
            <div slot="card-header">

              Market Exchange
            </div>
            <div slot="card-subheader">Minim do incididunt et sit. </div>
            <div slot="card-body">
              <echart-trader></echart-trader>
            </div>
          </base-card>
        </v-col>

        <v-col cols="12" md="2" sm="12">
          <base-card>
            <div slot="card-header">

              <v-sparkline :value="value" :fill="fill1" color="rgba(255, 255, 255, .7)" height="150" padding="24"
                           elevation="3" stroke-linecap="round" smooth>
                <template v-slot:label="item">
                  ${{ item.value }}
                </template>
              </v-sparkline>

            </div>
            <div slot="card-body">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 font-weight-black white--text">
                    BATUSDT
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption font-weight-light white--text">$0.00000987
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="2" sm="12">
          <base-card>
            <div slot="card-header">

              <v-sparkline :value="value" :fill="fill1" color="rgba(255, 255, 255, .7)" height="150" padding="24"
                           elevation="3" stroke-linecap="round" smooth>
                <template v-slot:label="item">
                  ${{ item.value }}
                </template>
              </v-sparkline>

            </div>
            <div slot="card-body">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 font-weight-black white--text">
                    ZILUSDT
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption font-weight-light white--text">$.00012987
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="2" sm="12">
          <base-card>
            <div slot="card-header">

              <v-sparkline :value="value" :fill="fill1" color="rgba(255, 255, 255, .7)" height="150" padding="24"
                           elevation="3" stroke-linecap="round" smooth>
                <template v-slot:label="item">
                  ${{ item.value }}
                </template>
              </v-sparkline>

            </div>
            <div slot="card-body">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 font-weight-black white--text">
                    BNBUSDT
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption font-weight-light white--text">$352.00
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="2" sm="12">
          <base-card>
            <div slot="card-header">

              <v-sparkline :value="value" :fill="fill1" color="rgba(255, 255, 255, .7)" height="150" padding="24"
                           elevation="3" stroke-linecap="round" smooth>
                <template v-slot:label="item">
                  ${{ item.value }}
                </template>
              </v-sparkline>

            </div>
            <div slot="card-body">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 font-weight-black white--text">
                    CAKEUSDT
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption font-weight-light white--text">$135.987
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="2" sm="12">
          <base-card>
            <div slot="card-header">

              <v-sparkline :value="value" :fill="fill1" color="rgba(255, 255, 255, .7)" height="150" padding="24"
                           elevation="3" stroke-linecap="round" smooth>
                <template v-slot:label="item">
                  ${{ item.value }}
                </template>
              </v-sparkline>

            </div>
            <div slot="card-body">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 font-weight-black white--text">
                    LINKUSDT
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption font-weight-light white--text">$25.987
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="2" sm="12">
          <base-card>
            <div slot="card-header">

              <v-sparkline :value="value" :fill="fill1" color="rgba(255, 255, 255, .7)" height="150" padding="24"
                           elevation="3" stroke-linecap="round" smooth>
                <template v-slot:label="item">
                  ${{ item.value }}
                </template>
              </v-sparkline>

            </div>
            <div slot="card-body">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 font-weight-black white--text">
                    BTCUSDT
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption font-weight-light white--text">$35.987
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
          </base-card>
        </v-col>



      </template>
    </v-row>


  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader';
  import EchartTrader from '../../components/Charts/EchartTrader'
  export default {
    components: {
      BaseCard,
      BaseHeader,
      EchartTrader
    },
    data() {
      return {
        selectedItem: 2,
        fill: true,
        rating: 5,
        labels: [
          '12am',
          '3am',
          '6am',
          '9am',
          '12pm',
          '3pm',
          '6pm',
          '9pm',
        ],
        value: [
          200,
          675,
          410,
          390,
          310,
          460,
          250,
          240,
        ],
        fill1: true,

        list1: [{
            color: 'accent',
            icon: 'trending_down',
            price: '-4%',
            title: 'BNB',
            switch1: false
          },
          {
            color: 'primary',
            icon: 'trending_up',
            price: '+14%',
            title: 'ENJ',
            switch1: false

          },
          {
            color: 'accent',
            icon: 'trending_down',
            price: '-4%',
            title: 'BNB',
            switch1: false
          },
          {
            color: 'primary',
            icon: 'trending_up',
            price: '+14%',
            title: 'ENJ',
            switch1: false

          }, {
            color: 'accent',
            icon: 'trending_down',
            price: '-4%',
            title: 'BNB',
            switch1: false
          },
          {
            color: 'primary',
            icon: 'trending_up',
            price: '+14%',
            title: 'ENJ',
            switch1: false

          },
        ],
        list2: [{
            color: 'primary',
            icon: 'work_outline',
            subtitle: 'Active',
            title: 'Home Office',
            switch1: true

          },
          {
            color: 'primary',
            icon: 'monetization_on',
            subtitle: 'Active',
            title: 'Responsibility',
            switch1: false

          },
          {
            color: 'primary',
            icon: 'support',
            subtitle: 'Active',
            title: 'Forum Religion',
            switch1: false

          },

        ],
      }
    },

  }
</script>

<!--====  End of MARKET  ====-->